<template>
    <v-col cols="12" md="6" sm="6" xs="12">
        <v-select
            density="compact" variant="outlined"
            v-model="form.copier.prints_per_month"
            label="How many prints do you print per month?"
            :items="[{title:'---',value:null},'1-100','100-300','300-500','500+']">
        </v-select>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
